import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

import { Logo } from '../Logo/Logo.tsx';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    globalThis.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      // Plain elements, no Mantine: this boundary sits outside MantineProvider so it also catches
      // errors in the provider itself, and a Mantine fallback would then crash in turn.
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            minHeight: '100dvh',
            fontFamily: 'Outfit Variable, sans-serif',
            textAlign: 'center',
          }}
        >
          <Logo />
          <h2 style={{ margin: '32px 0 0', fontFamily: 'Syne Variable, sans-serif', fontSize: '2.5rem' }}>
            Something went wrong
          </h2>
          <p style={{ margin: 0, color: '#868e96', fontSize: 14 }}>An unexpected error occurred. Please try again.</p>
          <button
            style={{
              marginTop: 8,
              padding: '10px 24px',
              border: 0,
              borderRadius: 999,
              background: '#191919',
              color: '#fff',
              font: 'inherit',
              cursor: 'pointer',
            }}
            type="button"
            onClick={this.handleReload}
          >
            Back to home
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
